import useMountEffect from '@restart/hooks/useMountEffect';
import classNames from 'classnames/bind';
import React from 'react';

import styles from './ContainerFullHeight.module.scss';

const cx = classNames.bind(styles);

const ContainerFullHeight = ({ children, className }) => {
  useMountEffect(() => {
    const setVh = () => {
      document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
    };

    setVh();
    window.addEventListener('resize', setVh);
    window.addEventListener('orientationchange', setVh);

    return () => {
      window.removeEventListener('resize', setVh);
      window.removeEventListener('orientationchange', setVh);
    };
  });

  return <div className={cx('container', className)}>{children}</div>;
};

export default ContainerFullHeight;
